/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { createDataActionHook, IActionContext, IActionInput } from '@msdyn365-commerce/core';
import { Cart } from '@msdyn365-commerce/retail-proxy';

const beforeRead = async (inputs: IActionInput | IActionInput[]) => {
    // placeholder
};

const afterRead = async (_inputs: IActionInput | IActionInput[], cart: Cart | Cart[], actionContext: IActionContext) => {
    try {
        const activeCart = await Promise.resolve(Array.isArray(cart) ? cart[0] : cart);
        actionContext.requestContext.telemetryData.activeCart = activeCart;
    } catch (e) {
        actionContext.telemetry.debug('ReadCart post-data action hook failed.', e);
    }
};

createDataActionHook({
    actionId: '@msdyn365-commerce/retail-proxy/Carts/Read',
    postReaderHook: afterRead,
    preReaderHook: beforeRead
});
